import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let pusher_app_key = '';
let pusher_app_cluster = '';

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: $('meta[name="pusher_app_key"]').attr('content'),
    cluster: $('meta[name="pusher_app_cluster"]').attr('content'),
    forceTLS: true
});

let messageHeader = $('#chat-header');

if (messageHeader.length > 0) {
    let chatWrapper = $('.chat-history');
    let messageHeaderID = messageHeader.attr('data-id');
    let channel = `messages.${messageHeaderID}`;
    chatWrapper.animate({scrollTop: $(document).height()}, 1000);
    window.Echo.private(channel)
        .listen('MessageStored', (e) => {
            if (window.userID !== e.userID) {
                chatWrapper.find('ul').append(e.html);
                chatWrapper.animate({
                    scrollTop: chatWrapper.prop('scrollHeight')
                }, 1000);
            }
        });
}
